import React from 'react';

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const ButtonMailto = ({ mailto, label }: { mailto: string; label: string }) => (
    <a href={mailto} className="text-blue-400 hover:text-blue-500">
      {label}
    </a>
  );

  const InstagramLogo = require('../../../assets/images/instagram.png');
  const FacebookLogo = require('../../../assets/images/facebook.png');
  const TwitterLogo = require('../../../assets/images/twitter.png');
  const TikTokLogo = require('../../../assets/images/tiktok.png');
  const Logo = require('../../../assets/images/xencode.png');

  const linkStyle = 'hover:cursor-pointer';

  return (
    <>
      <footer className="text-white bg-xencode-contact-black border-t-2 border-xencode-gold">
        <div className="max-w-6xl mx-auto px-4 md:px-8 py-20 grid grid-cols-1 md:grid-cols-4 gap-10">
          {/* Branding + Services */}
          <div>
            <a onClick={() => scrollTo('home')}>
              <img src={Logo} alt="Xencode" className="w-36 hover:cursor-pointer mb-4" />
            </a>
            <h2 className="font-bold text-lg text-xencode-gold mb-2">Services</h2>
            <ul className="space-y-2 text-sm text-gray-300">
              <li>Startup Business Web Design</li>
              <li>Website Rebuilds / Upgrades</li>
              <li>Ecommerce</li>
              <li>Mobile App</li>
            </ul>
          </div>

          {/* Navigation Links */}
          <div>
            <h2 className="font-bold text-lg text-xencode-gold mb-2 mt-4 md:mt-0">Links</h2>
            <ul className="space-y-2 text-sm text-gray-300">
              <li className={linkStyle} onClick={() => scrollTo('home')}>
                Home
              </li>
              <li className={linkStyle} onClick={() => scrollTo('services')}>
                Services
              </li>
              <li className={linkStyle} onClick={() => scrollTo('projects')}>
                Projects
              </li>
              <li className={linkStyle} onClick={() => scrollTo('about')}>
                About
              </li>
              <li className={linkStyle} onClick={() => scrollTo('contact')}>
                Contact
              </li>
            </ul>
          </div>

          {/* Social Media */}
          <div>
            <h2 className="font-bold text-lg text-xencode-gold mb-2 mt-4 md:mt-0">Social Media</h2>
            <div className="flex space-x-4 mt-2">
              <a
                href="https://www.facebook.com/profile.php?id=100090099461564"
                target="_blank"
                rel="noreferrer"
              >
                <img src={FacebookLogo} alt="Facebook" className="w-8 hover:opacity-80" />
              </a>
              <a href="https://www.instagram.com/xencode__/" target="_blank" rel="noreferrer">
                <img src={InstagramLogo} alt="Instagram" className="w-8 hover:opacity-80" />
              </a>
              <a href="https://www.tiktok.com/@vezzbys?lang=en" target="_blank" rel="noreferrer">
                <img src={TikTokLogo} alt="TikTok" className="w-8 hover:opacity-80" />
              </a>
            </div>
          </div>

          {/* Support / Contact */}
          <div>
            <h2 className="font-bold text-lg text-xencode-gold mb-2 mt-4 md:mt-0">Support</h2>
            <ul className="text-sm text-gray-300 mt-2">
              <li>
                <a href="tel:+27683882389" style={{ textDecoration: 'none', color: 'inherit' }}>
                  +27 68 388 2389
                </a>
              </li>
            </ul>
          </div>
        </div>
      </footer>

      {/* Bottom bar */}
      <div className="bg-black py-4 text-xs text-gray-500">
        <div className="max-w-6xl mx-auto px-4 md:px-8 flex flex-col md:flex-row justify-between items-center gap-2">
          <p>© COPYRIGHT {currentYear}. ALL RIGHTS RESERVED</p>
          <p>
            WEBSITE DESIGN BY <span className="text-xencode-gold">XenCode</span>
          </p>
        </div>
      </div>
    </>
  );
};
